import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { payments } from '../../node_modules/@square/web-sdk/dist/payments.es.js';
import ErrorScreen from '../../components/error-screen/error-screen.es.js';
import { useDynamicCallback } from '../../hooks/use-dynamic-callback.es.js';
var FormContext = React.createContext({
  cardTokenizeResponseReceived: null,
  createPaymentRequest: null,
  payments: null
});

function FormProvider(_ref) {
  var applicationId = _ref.applicationId,
      locationId = _ref.locationId,
      children = _ref.children,
      overrides = _ref.overrides,
      props = _objectWithoutProperties(_ref, ["applicationId", "locationId", "children", "overrides"]);

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      instance = _React$useState2[0],
      setInstance = _React$useState2[1];

  var _React$useState3 = React.useState(function () {
    var _props$createPaymentR;

    return (_props$createPaymentR = props.createPaymentRequest) === null || _props$createPaymentR === void 0 ? void 0 : _props$createPaymentR.call(props);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      createPaymentRequest = _React$useState4[0];

  React.useEffect(function () {
    var abortController = new AbortController();
    var signal = abortController.signal;

    function loadPayment(_x) {
      return _loadPayment.apply(this, arguments);
    }

    function _loadPayment() {
      _loadPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signal2) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return payments(applicationId, locationId, overrides).then(function (res) {
                  if (res === null) {
                    throw new Error("Square Web Payments SDK failed to load");
                  }

                  if (signal2 === null || signal2 === void 0 ? void 0 : signal2.aborted) {
                    return;
                  }

                  setInstance(res);
                  return res;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadPayment.apply(this, arguments);
    }

    if (applicationId && locationId) {
      loadPayment(signal);
    }

    return function () {
      abortController.abort();
    };
  }, [applicationId, locationId]);

  var cardTokenizeResponseReceived = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(rest) {
      var verifyBuyerResults;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(rest.errors || !props.createVerificationDetails)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return props.cardTokenizeResponseReceived(rest);

            case 3:
              return _context2.abrupt("return");

            case 4:
              _context2.next = 6;
              return instance === null || instance === void 0 ? void 0 : instance.verifyBuyer(String(rest.token), props.createVerificationDetails());

            case 6:
              verifyBuyerResults = _context2.sent;
              _context2.next = 9;
              return props.cardTokenizeResponseReceived(rest, verifyBuyerResults);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function cardTokenizeResponseReceived(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var cardTokenizeResponseReceivedCallback = useDynamicCallback(cardTokenizeResponseReceived);

  if (!applicationId || !locationId) {
    return /* @__PURE__ */React.createElement(ErrorScreen, null);
  }

  if (!instance) return null;
  var context = {
    cardTokenizeResponseReceived: cardTokenizeResponseReceivedCallback,
    createPaymentRequest: createPaymentRequest,
    payments: instance
  };
  return /* @__PURE__ */React.createElement(FormContext.Provider, {
    value: context
  }, children);
}

var useForm = function useForm() {
  var context = React.useContext(FormContext);

  if (context === void 0) {
    throw new Error("useForm must be used within a FormProvider");
  }

  return context;
};

export { FormContext, FormProvider as default, useForm };